import type { StoreApi } from 'zustand'
import type { createVerifyAccountActions } from '../domain/verifyAccountActions'
import type { VerifyAccountStore } from '../domain/verifyAccountTypes'
import * as React from 'react'

interface VerifyAccountDependencies {
  actions: ReturnType<typeof createVerifyAccountActions>
  store: StoreApi<VerifyAccountStore>
}

const VerifyAccountContext = React.createContext<VerifyAccountDependencies | null>(null)

export function VerifyAccountDependenciesProvider({
  children,
  dependencies,
}: React.PropsWithChildren<{ dependencies: VerifyAccountDependencies }>) {
  return <VerifyAccountContext value={dependencies}>{children}</VerifyAccountContext>
}

export function useVerifyAccountDependencies() {
  const dependencies = React.use(VerifyAccountContext)
  if (!dependencies)
    throw new Error('Account verification dependencies not provided')
  return dependencies
}
